<template>
  <div>
    <p><span>Call or text</span> at 707.477.1658</p>
  </div>
</template>

<script>
export default {
  name: "ContactCTA"
}
</script>

<style scoped>

p {
  text-align: center;
}

span {
  font-weight: bold;
}
</style>